import { getSessionToken } from '@/lib/auth'
import { createFileRoute, lazyRouteComponent, redirect } from '@tanstack/react-router'

const AccountSettingsRoute = lazyRouteComponent(
  () => import('@/features/account/AccountSettings'),
  'AccountSettings'
)

export const Route = createFileRoute('/conta/configuracoes')({
  beforeLoad: () => {
    if (!getSessionToken()) {
      throw redirect({ to: '/entrar' })
    }
  },
  component: AccountSettingsRoute,
})
